<template>
  <div class="player" :class="pos">
    <div class="number">{{ player.number }}</div>
    <div class="playername">
      {{ player.name + " " + player.surname }}
    </div>
    <div v-if="player.is_keeper" class="goalkeeper"></div>
    <div v-if="player.is_captain" class="captain"></div>
    <div
      v-if="parseInt(player.goals) > 0"
      class="goals"
      :class="{ extended: parseInt(player.goals) > 1 }"
    >
      <span v-if="parseInt(player.goals) > 1" class="extended"
        >({{ player.goals }})</span
      >
    </div>
    <div
      v-if="parseInt(player.yellow) > 0"
      class="yellow-card"
      :class="{ extended: parseInt(player.yellow) > 1 }"
    >
      <span v-if="parseInt(player.yellow) > 1" class="extended"
        >({{ player.yellow }})</span
      >
    </div>
    <div v-if="parseInt(player.red) > 0" class="red-card"></div>
    <div v-if="parseInt(player.current_sanction) > 0">
      ({{ player.current_sanction }})
    </div>
  </div>
</template>

<script>
export default {
  props: ["player", "position"],
  components: {},
  data: function() {
    return {
      pos: "left"
    };
  },
  created() {
    this.pos = this.position ? this.position : "l";
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
.player {
  display: inline-block;

  .number {
    width: 24px;
    background-color: #003784;
    border-radius: 50%;
    font-size: 16px;
    color: #fff;
    font-weight: bold;
    text-align: center;
    position: relative;
    float: left;
  }

  .playername {
    font-size: 16px;
    font-weight: bold;
    position: relative;
    width: fit-content;
    padding: 0 10px;
    float: left;
  }

  .goalkeeper {
    content: " ";
    width: 20px;
    height: 20px;
    float: left;
    background: url(/img/goalkeeper.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;
  }
  .captain {
    content: " ";
    width: 20px;
    height: 20px;
    float: left;
    background: url(/img/captain.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;
  }
  .goals {
    content: " ";
    width: 20px;
    height: 20px;
    float: left;
    background: url(/img/football-ball.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;

    &.extended {
      content: inherit;
      width: fit-content;

      span {
        padding-left: 40px;
        font-size: 14px;
      }
    }
  }
  .yellow-card {
    content: " ";
    width: 20px;
    height: 20px;
    float: left;
    background: url(/img/yellow-card.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;

    &.extended {
      content: inherit;
      width: fit-content;

      span {
        padding-left: 40px;
        font-size: 14px;
      }
    }
  }
  .red-card {
    content: " ";
    width: 20px;
    height: 20px;
    float: left;
    background: url(/img/red-card.svg);
    background-size: 20px;
    background-repeat: no-repeat;
    background-position: center;
  }

  &.r {
    .number {
      float: right;
    }
    .playername {
      float: right;
    }
    .goalkeeper {
      float: right;
    }
    .captain {
      float: right;
    }
    .goals {
      float: right;
    }
    .yellow-card {
      float: right;
    }
    .red-card {
      float: right;
    }
  }
}
</style>
